import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { CurrencyService } from "appworks/services/currency/currency-service";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { slotModel } from "slotworks/model/slot-model";
import { RadioControl } from "./radio-control";

export class AutoLossLimitRadioControl extends RadioControl {

    constructor(protected buttons: FlexiButton[], protected labels: FlexiText[], protected leftArrow?: FlexiButton, protected rightArrow?: FlexiButton, decimals: boolean = true) {
        super(buttons, labels, leftArrow, rightArrow);

        this.setFormatMethod((value: number) => {
            if (value === Number.MAX_VALUE) {
                return Services.get(TranslationsService).getFirstValid(["infinity", "curr.inf"]);
            } else {
                return Services.get(CurrencyService).format(value, decimals);
            }
        });
        const lossLimit = slotModel.read().autoplay.lossLimit;
        lossLimit.currentValue = undefined;
        this.setValues(lossLimit.values, lossLimit.currentValue);
        this.onChange(lossLimit.values.indexOf(lossLimit.currentValue), lossLimit.currentValue);

        slotModel.onUpdate.add(() => {
            const newLossLimit = slotModel.read().autoplay.lossLimit;
            this.setValues(newLossLimit.values, newLossLimit.currentValue);
            this.onChange(newLossLimit.values.indexOf(newLossLimit.currentValue), newLossLimit.currentValue);
        });
    }

    protected onChange(index: number, value: number): void {
        super.onChange(index, value);

        const autoplay = slotModel.read().autoplay;

        if (value !== autoplay.lossLimit.currentValue) {
            autoplay.lossLimit.currentValue = value;
            slotModel.write({ autoplay });
        }
    }
}
